'use client';

import clsx from 'clsx';
import { FC, SyntheticEvent, useState } from 'react';
import { Body } from 'atoms/Typography/Typography';
import { DeliveryInfo } from 'molecules/DeliveryInfo';
import { Tooltip } from 'molecules/Tooltip';
import { useTranslations } from 'modules/i18n/useTranslations';
import styles from './DeliveryStatus.module.css';

export enum DeliveryStatusType {
  AVAILABLE = 'green',
  PARTIALY_AVAILABLE = 'yellow',
  NOT_AVAILABLE = 'red',
}

export const DeliveryStatus: FC<{
  status: DeliveryStatusType;
  hovered?: boolean;
  textClassName?: string;
}> = ({ status, hovered, textClassName }) => {
  const t = useTranslations();

  const [open, setOpen] = useState(false);

  const toggleOpen = (
    e: Event | SyntheticEvent<Element, Event>,
    isOpen: boolean,
  ) => {
    e.stopPropagation();
    e.preventDefault();
    setOpen(isOpen);
  };

  const deliveryText =
    status === DeliveryStatusType.NOT_AVAILABLE
      ? t('product.pdp.soldOutLabel')
      : t('product.tile.delivery');

  return (
    <div className={styles.root}>
      <span className={clsx(styles.marker, styles[status])} />
      {!hovered && (
        <Tooltip
          onClose={(e) => toggleOpen(e, false)}
          open={open}
          element={<DeliveryInfo />}
          isLarge
        >
          <span onClick={(e) => toggleOpen(e, true)}>
            <Body
              tag="span"
              type="sm"
              weight="medium"
              className={clsx(styles.text, textClassName)}
            >
              {deliveryText}
            </Body>
          </span>
        </Tooltip>
      )}
    </div>
  );
};
